// client/plugins/currentPathBarPlugin.ts
import { NodeSelection, Plugin } from "prosemirror-state";
var CurrentPathConfig = {
  plugins: (schema) => [getCurrentPathPlugin()]
};
function getBreadcrumbPath(state) {
  const selection = state.selection;
  const path = [];
  const positions = [];
  if (selection instanceof NodeSelection) {
    const { $anchor } = selection;
    for (let i = 1; i <= $anchor.depth; i++) {
      const node = $anchor.node(i);
      path.push(node.type.name);
      positions.push($anchor.before(i));
    }
    path.push(selection.node.type.name);
    positions.push(selection.$from.pos);
    return { path, positions, isNodeSelection: true };
  }
  const { $from } = selection;
  for (let i = 1; i <= $from.depth; i++) {
    const node = $from.node(i);
    path.push(node.type.name);
    positions.push($from.before(i));
  }
  return { path, positions, isNodeSelection: false };
}
function getCurrentPathPlugin() {
  return new Plugin({
    view(editorView) {
      const breadcrumb = document.createElement("div");
      breadcrumb.style.position = "sticky";
      breadcrumb.style.bottom = "0";
      breadcrumb.style.left = "0";
      breadcrumb.style.width = "100%";
      breadcrumb.style.padding = "10px";
      breadcrumb.style.backgroundColor = "var(--color-base-200, #F2F2F1)";
      breadcrumb.style.borderTop = "1px solid var(--color-base-300, #ddd)";
      breadcrumb.style.textAlign = "left";
      breadcrumb.style.fontSize = "14px";
      breadcrumb.style.color = "var(--color-base-content, #333)";
      breadcrumb.style.zIndex = "1000";
      breadcrumb.style.boxSizing = "border-box";
      const updateBreadcrumb = () => {
        const { path, positions, isNodeSelection } = getBreadcrumbPath(editorView.state);
        breadcrumb.innerHTML = "";
        path.forEach((name, index) => {
          const span = document.createElement("span");
          span.textContent = name;
          span.style.cursor = index === path.length - 1 && isNodeSelection ? "default" : "pointer";
          span.style.marginRight = "8px";
          span.style.color = index === path.length - 1 && isNodeSelection ? "var(--color-primary, #000)" : "var(--color-base-content, #007bff)";
          if (!(index === path.length - 1) || !isNodeSelection) {
            span.onclick = () => {
              const pos = positions[index];
              const resolvedPos = editorView.state.doc.resolve(pos);
              const node = resolvedPos.node(index <= resolvedPos.depth ? index : resolvedPos.depth);
              if (node) {
                const transaction = editorView.state.tr.setSelection(NodeSelection.create(editorView.state.doc, pos));
                editorView.dispatch(transaction);
              }
              editorView.focus();
              setTimeout(updateBreadcrumb, 0);
            };
          }
          breadcrumb.appendChild(span);
          if (index < path.length - 1) {
            const arrow = document.createElement("span");
            arrow.textContent = " > ";
            arrow.style.marginRight = "8px";
            breadcrumb.appendChild(arrow);
          }
        });
        if (breadcrumb.children.length === 0)
          breadcrumb.innerText = "Kein g\xFCltiger Pfad gefunden.";
      };
      updateBreadcrumb();
      if (editorView.dom.parentNode) {
        editorView.dom.parentNode.appendChild(breadcrumb);
      } else {
        console.error("Parent node for breadcrumb is not available");
      }
      return {
        update(view) {
          updateBreadcrumb();
        },
        destroy() {
          breadcrumb.remove();
        }
      };
    }
  });
}
export {
  CurrentPathConfig,
  getCurrentPathPlugin
};
